export default {
  404: '404',
  register: 'Register',
  login: 'Login',
  profit: 'Profit',
  payout: 'Target Payout',
  btnDouble: '2×',
  wagered: 'Wagered',
  deposit: 'Deposit',
  inputFieldBtnMax: 'Max',
  bets: 'Bets',
  topHeaderAmount: 'Amount',
  resetPasswordTitle: 'Reset Password',
  resetPasswordNewPasswordTitle: 'New Password',
  resetPasswordNewPasswordErrorsRequired: 'Password is required.',
  resetPasswordNewPasswordErrorsMinLength: 'Minimum 8 characters allowed.',
  resetPasswordNewPasswordErrorsMaxLength: 'Maximum 16 characters allowed.',
  resetPasswordNewPasswordErrorsPattern: 'Must be 8-16 characters, including uppercase and lowercase letters, numbers, and a special character (e.g., Coinbatting@123)',
  resetPasswordConfirmPasswordTitle: 'Confirm Password',
  resetPasswordConfirmPasswordErrorsNotMatched: 'Passwords do not match.',
  resetPasswordResetBtn: 'Reset',
  passwordResetSuccess: 'Password changed',
  resetPasswordWentWrong: 'Something went wrong!',
  partners: 'Partners',
  submit: 'Submit',
  signinUsername: 'Email / Username',
  signinForgetPassword: 'Forgot Password?',
  signinErrorsUserNameRequired: 'Please enter username/email.',
  signinErrorsPasswordRequired: 'Password is required.',
  signinErrorsPasswordMinLength: 'Minimum 8 characters allowed.',
  signinErrorsPasswordMaxLength: 'Maximum 16 characters allowed.',
  signinTryAgain: 'Something went wrong!, Please try again.',
  signinResetPasswordUsernameErr: 'Please enter username/email to reset password.',
  signinResetMailSentSuccessContent: 'We sent you a reset password link on your email. Please check your email and reset your password.',
  signUp: 'Sign Up',
  signupTitle: 'Register',
  signupUsername: 'Username',
  signupEmail: 'Email',
  signupWalletConnect: 'Login with Wallet ',
  signupPassword: 'Password',
  signupErrorsUserNameRequired: 'Please enter username.',
  signupErrorsUserNameMinLength: 'Minimum 5 characters allowed.',
  signupErrorsUserNameMaxLength: 'Maximum 20 characters allowed.',
  signupErrorsUserNamePattern: 'Please enter only letters and numbers.',
  signupErrorsEmailRequired: 'Please enter email.',
  signupErrorsEmailPattern: 'Please enter valid email.',
  signupErrorsPasswordRequired: 'Password is required.',
  signupErrorsPasswordMinLength: 'Minimum 8 characters allowed.',
  signupErrorsPasswordMaxLength: 'Maximum 16 characters allowed.',
  signupErrorsPasswordPattern: 'Must be 8-16 characters, including uppercase and lowercase letters, numbers, and a special character (e.g., Coinbatting@123)',
  otpIsRequired: 'OTP is required',
  otpMustBeSixDigits: 'OTP must be 6 digits',
  enterOtp: 'Enter OTP',
  emailChangeOtpSent: 'A 6-digit code for verification was sent to the new email address. Please check and enter it.',
  accountMenuTransactions: 'Transactions',
  accountMenuPromotions: 'Promotions',
  accountMenuProfile: 'Profile',
  accountMenuLogout: 'Logout',
  accountMenuWithdraw: 'Withdraw',
  pageNotFound: 'We can’t find the page you are looking for!',
  error: 'Error',
  somethingWentWrong: 'Something went wrong!',
  verifyEmailThankYou: 'Thank You!',
  verifyEmailEmailIsVerified: 'Your email is verified.',
  verifyEmailWentWrong: 'Something went wrong!',
  verifyEmailTokenExpired: 'Email already verified or link expired',
  create: 'Create',
  profilePassword: 'Password',
  profileUploadProfile: 'Upload Photo',
  profileErrorsEmailRequired: 'Email is required.',
  profileErrorsEmailPattern: 'Please enter valid email.',
  profileErrorsEmailMinLength: 'Minimum 3 characters allowed.',
  profileErrorsEmailMaxLength: 'Maximum 20 characters allowed.',
  profileMessagesProfileUpdate: 'Profile updated',
  profileMessagesChangePassword: 'Password updated',
  profileProfilePicProfilePicUpload: 'Upload profile image',
  profileNoNewChanges: 'Couldn’t update profile! No new changes.',
  profileLoggedInWithSocial: 'You have logged in with social login.',
  profileSideNavigatorSound: 'Sound',
  profileSideNavigatorMusic: 'Music',
  profileSideNavigatorProfile: 'My Profile',
  profileSideNavigatorBetHistory: 'Bet History',
  profileSideNavigatorTransactions: 'Transactions',
  profileSideNavigatorDeposit: 'Deposit',
  profileSideNavigatorWithdraw: 'Withdraw',
  // profileSideNavigatorGameLimits: 'Game Limits',
  profileSideNavigatorReferral: 'Referral',
  profileSideNavigatorChangePassword: 'Change Password',
  profileSideNavigatorTermsConditions: 'Terms & Conditions',
  profileSideNavigatorLogOut: 'Log Out',
  profileSideNavigatorProvablyFair: 'Provably Fair',
  WalletInfoSectionNotAvailable: 'Not Available',
  WalletInfoSectionRealBalance: 'Real Balance',
  GameLimitsMinimumBet: 'Minimum bet',
  GameLimitsMaximumBet: 'Maximum bet',
  GameLimitsMaxWinFor1Bet: 'Maximum win fir one bet',
  ProvablyFairSubTitle: 'This game uses Provably Fair technology to determine game result. This tool gives you ability to change your seed and check fairness of the game.',
  ProvablyFairMaximumBet: 'Maximum bet:',
  ProvablyFairMaxWinFor1Bet: 'Maximum win fir one bet',
  promotionsTitle: 'Promotions',
  promotionsNoLosingData: 'Sorry, No Losing bonus promotions available for ',
  promotionsNoDepositData: 'Sorry, No Deposit bonus promotions available for ',
  promotionsCurrency: ' currency.',
  promotionsViewBtn: 'View',
  promotionsClaimSuccess: 'You have successfully claimed',
  promotionsAvailability: 'Availability: ',
  promotionsAvailabilityTabLosing: 'Losing bonus',
  promotionsAvailabilityTabDeposit: 'Deposit bonus',
  promotionsDepositBonusTableCode: 'Code',
  promotionsDepositBonusTableMinDeposit: 'Min. Deposit',
  promotionsDepositBonusTablePercentage: 'Percentage',
  promotionsDepositBonusTableMaxBonus: 'Max Bonus',
  promotionsDepositBonusTableRolloverMultipler: 'Rollover multiplier',
  promotionsDepositBonusTableMaxRolloverPerBet: 'Max rollover per bet',
  promotionsDepositBonusTableTimeToAchieveRolloverTarget: 'Time to achieve rollover target',
  promotionsBonusCode: 'BONUS CODE: ',
  promotionsLossesClaim: 'Losses can be claimed for(within campaign period): ',
  promotionsLossesClaimLosingBonusTablePercentage: 'Percentage',
  promotionsLossesClaimLosingBonusTableMinLosingAmount: 'Min. losing amount',
  promotionsBonusStatus: 'Bonus Status: ',
  promotionsBonusAmount: 'Bonus Amount: ',
  promotionsRolloverTarget: 'Rollover target: ',
  promotionsRolloverAchieved: 'Rollover achieved: ',
  promotionsActivatebtn: 'ACTIVATE',
  promotionsClaimBtn: 'CLAIM',
  promotionsCancelBtn: 'CANCEL',
  promotionsBackBtn: 'BACK',
  promotionsBonus: 'Bonus',
  promotionsTermAndConditions: ' Terms & Conditions',
  promotionsClaimDepositBonusTitle: 'Steps for claiming deposit bonus',
  promotionsClaimDepositBonusFirst: 'Activate Bonus code',
  promotionsClaimDepositBonusSecond: 'Deposit amount to wallet',
  promotionsClaimDepositBonusThird: 'Achieve rollover target for claiming bonus',
  promotionsClaimLosingBonusTitle: 'Steps for claiming losing bonus',
  promotionsClaimLosingBonusFirst: 'Activate Bonus code',
  promotionsClaimLosingBonusSecond: 'Play your favorite games',
  promotionsClaimLosingBonusThird: 'Click ’Claim losses’ to claim losses within campaign period',
  promotionsWentWrong: 'Something went wrong!',
  transactionTitle: 'Transactions',
  transactionBetId: 'Bet ID',
  transactionUser: 'User',
  transactionPayout: 'Payout',
  transactionAmount: 'Amount',
  transactionTime: 'Date',
  transactionProfit: 'Profit',
  transactionCashout: 'Cashout',
  transactionBet: 'Bet',
  transactionMultix: 'Multi.x',
  transactionWin: 'Win',
  transactionFairness: 'Fairness',
  transactionReferFriend: 'Refer a Friend',
  transactionTotal: 'Total Bets',
  transactionWins: 'Wins',
  transactionRefresh: 'Refresh',
  transactionFilterTopMultipliers: 'Top Multipliers',
  transactionFilterHugeWins: 'Huge Wins',
  transactionFilterBiggestWins: 'Biggest Wins',
  transactionFilterMultipliers: 'Multipliers',
  transactionRealBalance: 'Real Balance',
  depositWithdrawTXDate: 'Date',
  depositWithdrawTXAmount: 'Amount',
  depositWithdrawTXTxId: 'TxID',
  depositWithdrawTXTxType: 'Transaction type',
  depositWithdrawTXStatus: 'Status',
  depositWithdrawTXNoData: 'No data available.',
  depositTitle: 'Deposit',
  depositHistory: 'History',
  depositSubTitle: 'User can not deposit or withdraw fiat currency. Please contact Admin to transact in fiat currency.',
  depositCopyNotSupported: 'Your browser does not support automatic Copy to Clipboard.\nPlease try to copy the code manually.',
  depositCopied: 'Address copied.',
  withdrawNoBalance: 'Not enough balance.',
  withdrawMinAmount: 'Please enter amount greater than or equal to {{min}} .',
  paginationNextBtn: 'Next',
  paginationPrevBtn: 'Previous',
  LoginRequired: 'Login required!',
  betPlacedSuccessfully: 'Bet Placed',
  betCancelledSuccessfully: 'Bet cancelled successfully',
  PlayerEscapedSuccessfully: 'Player exited',
  CopiedSuccessfull: 'Copied successfull',
  usersConsent: 'By accessing this site, I confirm that I am 18 years old, and have reviewed, \n understood and consented to the',
  termsOfService: 'Terms of Service',
  email: 'Email',
  playNow: 'Play Now',
  orContinueWith: 'Or Continue With',
  metamaskExtensionNotAvailable: 'Please install the metaMask extension and refresh the page.',
  cashier: 'CASHIER',
  account: 'ACCOUNT',
  hello: 'Hello',
  balance: 'Balance',
  // referrals: 'Referrals',
  settings: 'Settings',
  withdrawals: 'Withdrawals',
  demoWallet: 'Demo Wallet',
  wallet: 'Wallet',
  user: 'User',
  amountIsRequired: 'Amount is required',
  minDepositAmount: 'Deposit amount must be greater than {{min}}.',
  maxDepositAmount: 'Deposit amount must be less than {{max}}.',
  minWithdrawAmount: 'Must be greater than {{min}}',
  withdrawMustLessThanWallet: 'Withdraw amount must be less than your wallet amount',
  accountTypeIsRequired: 'Account type is required.',
  mobileNumberLength: 'Mobile number must be of {{length}} digits',
  phoneIsRequired: 'Phone is required',
  cpfError: 'CPF must be of {{length}} characters',
  cpfRequiredError: 'CPF is required',
  cnpjError: 'CNPJ must be of {{length}} characters',
  mainMenu: 'MAIN MENU',
  casino: 'Casino',
  sports: 'Sports',
  crypto: 'Crypto',
  clutchXp: 'coinbatting xp',
  playEarn: 'play & earn',
  NFT: 'NFT',
  poker: 'Poker',
  earnRewards: 'EARN REWARDS',
  rankUp: 'Rank Up',
  inviteFriends: 'Invite Friends',
  partnerProgram: 'Partner Program',
  sportsbook: 'Sportsbook',
  menu: 'Menu',
  allBets: 'All bets',
  highRollers: 'High Rollers',
  luckyBets: 'Lucky Bets',
  trade: 'Trade',
  player: 'PLAYER',
  time: 'TIME',
  wager: 'WAGER',
  payoutText: 'PAYOUT',
  bannerHeadOne: 'Experience true innovation with the highest',
  bannerHeadTwo: 'rewards program within the industry.',
  registerNow: 'Register now',
  copy: 'Copy',
  liveWins: 'LIVE WINS',
  monthlyStatus: 'M',
  weeklyStatus: 'W',
  dailyStatus: 'D',
  clutchEcosystem: 'coinbatting ecosystem',
  allGames: 'All Games',
  allSports: 'All Sports',
  cryptoFutures: 'crypto futures',
  tradeNow: 'Trade Now',
  $coinbatting: '$coinbatting',
  allTables: 'All Tables',
  nft: 'NFT',
  viewAll: 'View all',
  rewards: 'Rewards',
  profile: 'Profile',
  clutchProfile: 'COINBATTING PROFILE',
  totalBets: 'Total Bets',
  totalWagered: 'Total Wagered',
  joinDate: 'Join Date',
  displaySocialLinks: 'Display Linked Social Accounts',
  privateProfile: 'Private Profile',
  rank: 'Rank',
  nextRank: 'Next Rank',
  changeUsername: 'Change username',
  newPassword: 'New password',
  repeatNewPassword: 'Repeat new password',
  changeName: 'Change name',
  linkSocialAccount: 'Link social account',
  privateProfileTooltip: "Once your profile is set to private, other users won't be able to see your wagered activity, rewards, or social links",
  socialLinksTooltip: 'Link your social accounts to allow other users to follow you.',
  balances: 'balances',
  createReferralBalance: 'Create referral balance',
  total: 'Total',
  tips: 'Tips',
  receivedAmount: 'Received amount',
  dateOrTime: 'Date/Time',
  view: 'View',
  allChains: 'All Chains',
  creditAmount: 'Credit amount',
  // setCustomReferralLink: 'Set custom referrals link',
  changeEmail: 'Change email',
  newEmail: 'New email',
  newUsername: 'New username',
  username: 'Username',
  changePassword: 'Change password',
  twoFactorAuthentication: 'two-factor authentication',
  twoFactorAuthenticationTitle: 'Using Two-Factor Authentication Is Highly Recommended Because It Protects Your Account With Both Your Password And Your Phone. An Email And Password Must Be Set To Activate 2FA. While 2FA Is Enabled, You Will Not Be Able To Login Via Steam.',
  enable2fa: 'Enable 2FA',
  verifyIdentityByKyc: 'Verify your identity (kyc)',
  oldPassword: 'Old password',
  live: 'Live',
  soccer: 'Soccer',
  tennis: 'Tennis',
  fifa: 'Fifa',
  basketball: 'Basketball',
  iceHockey: 'Ice Hokey',
  volleyball: 'Volleyball',
  tableTennis: 'Table Tennis',
  baseball: 'Baseball',
  golf: 'Golf',
  boxing: 'Boxing',
  myBets: 'My Bets',
  favourites: 'Favourites',
  americanFootball: 'American Football',
  buyCrypto: 'Buy Crypto',
  oldEmail: 'Old email',
  loggedInSuccess: 'Login complete',
  loggedOutSuccess: 'Logout complete',
  signup: 'Registration complete',
  tokenVerify: 'Verification token sent to your email. Please verify',
  emailVerify: 'Email verified',
  emailChangedSuccess: 'Email updated',
  emailUpdateOtp: 'OTP sent to new mail',
  profileUpdatedSuccess: 'Profile updated',
  otpVerified: 'One-time password (OTP) verified',
  twoFADeactivated: 'Two-Factor Authentication disabled',
  internalServerError: 'Internal server error',
  unAuthorized: 'Unauthorized',
  dataNotFound: 'Data Not Found',
  setReferralLink: 'Set referral link...',
  notFound: 'Not Found',
  clutchOriginals: 'Originals',
  status: 'Status',
  success: 'Success',
  failed: 'Failed',
  pending: 'Pending',
  date: 'Date',
  to: 'To',
  roundId: 'Round ID',
  bet: 'Bet',
  win: 'Win',
  at: 'at',
  downloadAll: 'Download All',
  gameText: 'Game',
  searchGames: 'Search games',
  provider: 'Provider',
  search: 'Search',
  all: 'All',
  sortBy: 'Sort by',
  popular: 'Popular',
  loadMore: 'Load More',
  bitcoin: 'Bitcoin',
  btc: 'BTC',
  chat: 'Chat',
  loginToChat: 'Login to chat',
  send: 'Send',
  expand: 'Expand',
  collapse: 'Collapse',
  emailPlaceholder: 'youremail@domain.com',
  removeFromFavourite: 'Remove from favourites',
  addToFavourite: 'Add to favourites',
  verify: 'Verify',
  accountVerification: 'Account verification',
  recentlyPlayed: 'Recently Played',
  moreFrom: 'More from',
  demoMode: 'Demo Mode',
  providersList: 'Providers List',
  games: 'Games',
  providers: 'Providers',
  close: 'Close',
  joinedOn: 'Joined on',
  rewarded: 'Rewarded',
  saySomething: 'Say something',
  addressIsRequired: 'Address is required',
  invalidWalletAddressLength: 'Invalid {{currency}} wallet address length ({{actual}} characters). {{currency}} addresses must be {{expected}} characters.',
  invalidWalletAddressFormat: 'Invalid {{currency}} wallet address. Please check the address and try again.',
  withdrawExceedsMax: 'Amount exceeds the maximum withdrawable balance ({{max}} {{currency}}).',
  maxWithdrawAmountLabel: 'Maximum withdrawable: {{max}} {{currency}}',
  transactionPassword: 'Transaction password',
  transactionPasswordSetHint: 'Set a 6-digit password required to send crypto withdrawals.',
  transactionPasswordUpdateHint: 'Update your 6-digit transaction password periodically to keep withdrawals secure.',
  transactionPasswordRequired: 'Transaction password is required',
  transactionPasswordLength: 'Transaction password must be exactly 6 digits.',
  transactionPasswordsMustMatch: 'Transaction passwords must match',
  sixDigitTransactionPassword: '6-digit password',
  currentTransactionPassword: 'Current transaction password',
  newTransactionPassword: 'New transaction password',
  repeatNewTransactionPassword: 'Repeat new transaction password',
  setTransactionPassword: 'Set transaction password',
  updateTransactionPassword: 'Update transaction password',
  transactionPasswordUpdated: 'Transaction password updated',
  enterTransactionPassword: 'Enter transaction password',
  enterTransactionPasswordHint: 'Enter your 6-digit transaction password to continue this withdrawal.',
  transactionPasswordNotSetTitle: 'Transaction password required',
  transactionPasswordNotSetHint: 'Set a 6-digit transaction password in Account Settings before withdrawing crypto.',
  goToAccountSettings: 'Go to account settings',
  confirmWithdrawal: 'Confirm withdrawal',
  confirmWithdrawalHint: 'Please confirm you want to send this withdrawal. This cannot be undone after it is submitted.',
  confirmSend: 'Confirm send',
  withdrawalAddressLabel: 'To address',
  withdrawalAmountLabel: 'Amount',
  withdrawRequestSent: 'Withdrawal request submitted. Awaiting approval.',
  withdrawBeingVerified: 'Your withdrawal is being verified. Please do not submit another request until its status is confirmed.',
  withdrawPendingReview: 'CoinPayments rejected the withdrawal before creating a payout. The request remains pending for review.',
  noMatchesFound: 'No matches found',
  tip: 'TIP',
  sendTip: 'Send tip',
  minAmount: 'Amount must be greater than {{min}}',
  maxAmount: 'Amount must be less than {{max}}',
  doNotShowTip: "Don't show tip in chat",
  demoAvailable: 'Demo available',
  denoNotAvailable: 'Demo not available',
  goFullscreen: 'Go fullscreen',
  endsAt: 'Ends at',
  inProgress: 'In progress',
  eventEnd: 'Event end',
  latestPromotions: 'Latest Promotions',
  archived: 'Archived',
  noPromotionsFound: 'No promotions found',
  claim: 'Claim',
  add: 'Add',
  viewDashboard: 'View Dashboard',
  prize: 'Prize',
  timeLeft: 'Time Left',
  viewTransactions: 'View transactions',
  sendAmountInCashier: 'Send the amount of {{- currency}} of your choice to the following address to receive the equivalent in Coins.',
  yourPersonalDepositAddress: 'Your personal {{- currency}} deposit address',
  copyAddress: 'Copy address',
  theValueOfCurrencyMayChange: 'The value of {{- currency}} may change between now and the time we receive your payment',
  doNotHaveAnyCurrency: "Don't have any {{- currency}}?",
  depositOptions: 'Deposit options',
  withdrawalOptions: 'Withdrawal options',
  withdrawCurrency: 'Withdraw {{- currency}}',
  enterAddressToReceiveFunds: '  Please enter the {{- currency}} wallet address you wish to receive the funds on. Once confirmed, the withdrawal is usually processed within a few minutes.',
  receivingCurrencyAddress: 'Receiving {{- currency}} address',
  withdrawalAmount: 'Withdrawal amount',
  pasteYourCurrencyAddressHere: 'Paste your {{- currency}} wallet address here...',
  request: 'Request',
  receiveTheSpecifiedAmount: '*You will receive the specified {{- currency}} amount to your withdrawal address',
  valueMayVary: '*The value subtracted from your balance may vary between now and the time we process your withdrawal',
  withdrawalFeesMayApply: '*Withdrawal fees may apply, so the amount you receive could be slightly lower than the amount you withdraw',
  coupons: 'Coupons',
  updateEmail: 'Update email',
  update: 'Update',
  loginHistory: 'Login history',
  showLoginHistory: 'Show login history',
  wagerErr: 'Wager Amount is required',
  minWagerErr: 'Minimum wager amount is 1',
  mulValErr: 'Multiplier value between 1 - 1000',
  closeBetErr: 'Enter valid close bet amount',
  profitErr: 'Enter valid take profit amount',
  multiplierErr: 'Multiplier Amount is required',
  manual: 'Manual',
  auto: 'Auto',
  pnLFee: 'PnL Fee',
  flatFee: 'Flat Fee',
  takeProfitLabel: 'TAKE PROFIT AT PRICE',
  closeBetLabel: 'CLOSE BET AT PRICE',
  priceUpLabel: 'WILL THE PRICE GO UP OR DOWN?',
  up: 'Up',
  down: 'Down',
  payoutMul: 'PAYOUT MULTIPLIER',
  safe: 'Safe',
  wild: 'Wild',
  placeBet: 'Place Bet',
  roundEnd: 'ROUND ENDS IN',
  timerInfo: 'All Rollercoaster bets will be closed and price will reset to $1,000 each day at 00:00 UTC',
  month: 'month',
  PNL: 'PNL',
  ROI: 'ROI',
  roi: 'roi',
  funding: 'Funding/H',
  exitPriceLabel: 'Exit Price',
  cashedOut: 'Cashed Out',
  open: 'Open',
  chartPreferences: 'Chart Preferences',
  yAxis: 'Y-Axis Preferences',
  additionalFeatures: 'Additional Features',
  themes: 'Themes',
  locale: 'Locale',
  changeTimezone: 'Change Timezone',
  changeLanguage: 'Change Language',
  tooltip: 'Tooltip',
  field: 'Field',
  value: 'Value',
  dateTime: 'Date/Time',
  winningAmount: 'winningAmount',
  activeBets: 'Active bets',
  closedBets: 'Closed bets',
  publicBets: 'Public bets',
  leaderboard: 'Leaderboard',
  howToPlay: 'How To Play',
  rOICalculator: 'ROI Calculator',
  allInstruments: 'All Instruments',
  week: 'Week',
  monthLabel: 'Month',
  day: 'Day',
  betLabel: 'BET',
  entryPrice: 'ENTRY PRICE',
  bustPriceLabel: 'Bust Price',
  multiplierLabel: 'MULTIPLIER',
  exitPrice: 'EXIT PRICE',
  pnl: 'P&L',
  details: 'View details',
  profitLoss: 'P/L',
  noBalance: 'Not enough balance.',
  maxBetAmount: 'Max bet amount',
  limit: 'Limit',
  minBetAmount: 'Min bet amount',
  rollsLimitMsg: 'Number of rolls must be less than or equal to 100.',
  mines: 'Mines',
  loginFailed: 'Login failed',
  noEntries: 'No entries',
  descriptionIsRequired: 'Description is required',
  description: 'Description',
  report: 'Report',
  userReportedSuccessfully: 'User reported',
  tipSendSuccessfully: 'Tip sent',
  walletSettings: 'Wallet Settings',
  hideZero: 'Hide zero balances',
  hideZeroInfo: "Your zero balance won't appear in your wallet",
  displayFiat: 'Display crypto in fiat',
  displayFiatInfo: 'All bets & transactions will be settled in the crypto equivalent',
  noteForApprox: 'Please note that these are currency approximations.',
  save: 'Save',
  // limits: 'Limits',
  wagerLimit: 'Wager Limit',
  lossLimit: 'Loss Limit',
  depositLimit: 'Deposit Limit',
  takeABreak: 'Take A Break',
  customTimePeriod: 'Custom Time Period',
  timePeriod: 'Time Period',
  selfExclusion: 'Self Exclusion',
  confirm: 'Confirm',
  setLimit: 'Set Limit',
  removeLimit: 'Remove Limit',
  enterAmount: 'Enter Amount',
  hours: 'Hours',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  cancel: 'Cancel',
  usedLimit: 'Used Limit',
  type: 'Type',
  updatedAt: 'Updated At',
  editLimit: 'Edit Limit',
  limitRemovedMessage: 'Your Following Limit Will Be Removed.',
  setLimitMessage: 'You Are About To Set The Following Limit To Your Account. Please Note, That In Case You Want To Change The Limit, You Can Do That After 24hrs.',
  setBreakMessage: 'You Are About To Block The Access To Your Account For A Preset Period Of Time. Please Know That Once You Use The Option, You Will Not Be Able To Log In To Your Account To Change The Block Period. If You Would Like To Choose A Different Block Period Or Extend The Existing One, Please Contact Us Via Live Support.',
  setSessionLimitMessage: 'You Are About To Set The Following Limit To Your Account. Please Note, That In Case You Want To Change The Limit, It Will Take 24 Hours For The Limit To Be Changed After You Set Another Limit Amount.',
  removeSessionLimitMessage: 'Your Session Limit Will Be Removed',
  notAchieved: 'not achieved',
  flexibleRegistration: 'Flexible Registration!',
  mostPlayed: 'Most played',
  badge: 'Badges',
  allBadges: 'All Badges',
  socialMedia: 'Social media',
  allLinks: 'All Links',
  statistics: 'Statistics',
  newMessage: 'New message',
  tipFor: 'tip for',
  play: 'Play',
  betOn: 'Bet on',
  ecosystemUnbeatableOdds: 'Bet Better - Access unbeatable odds on exciting events with our top-tier betting platform!',
  startBetting: 'Start Betting',
  ecosystemJoinTheFun: 'Join the Fun - Explore Coinbatting’s exclusive games and over +9,000 casino favorites!',
  futures: 'Futures',
  ecosystemTrade: 'Trade Smarter, Maximize your Wins - Experience up to 1,000x leverage!',
  joinNow: 'Join Now',
  noNotificationsFound: 'No notifications found',
  notifications: 'Notifications',
  lobby: 'Lobby',
  rollercoaster: 'Coinbatting Coaster',
  applyReferralCode: 'Apply referral code',
  referralCode: 'Referral code',
  referralLink: 'Referral link',
  copyLink: 'Copy link',
  referralLinkCopied: 'Referral link copied',
  withdrawAddressCannotBeSame: 'Withdraw address cannot be same as yours address',
  userId: 'User id',
  active: 'Active',
  inactive: 'Inactive',
  currency: 'Currency',
  hostGames: 'Host games,',
  earnCrypto: 'Earn crypto',
  inviteHostAndEarn: 'Invite, Host & Earn - Run your own Coinbatting Events',
  startEarning: 'Start Earning',
  coinbatting: 'Coinbatting',
  whitePaper: 'Whitepaper',
  deepDiveInto: 'Dive Deep into the Coinbatting Coin Economy',
  learnMore: 'Learn More',
  sport: 'sport',
  vipRanked: 'Vip ranked',
  betMoreEarnMore: 'Bet More, Earn More - Maximize your Potential',
  expiresAt: 'Expires on',
  upload: 'Upload',
  pleaseSelectImage: 'Please select image',
  imageSizeMustLessThan: 'Image size must be less than {{size}} mb',
  imageSizeFormat: 'Use png, jpeg, jpg image format.',
  maxFileSize: 'Max. File Size: 2 MB',
  dragPosition: 'Drag to change position',
  onlyNumbers: 'Only Numbers',
  cannotBeRemoved: 'Cannot be removed',
  amountInBetween: 'Amount should be in between daily and monthly(inclusive)',
  amountEqualOrGreater: 'Amount equal or greater than weekly',
  amountEqualOrLess: 'Amount should be equal or less than weekly and monthly',
  cannotBeIncreased: 'Cannot be increased',
  enterPassword: 'Enter password',
  sessionLimit: 'Session Limit',
  timePeriodRequired: 'Time period is required',
  amountGTZero: 'Amount greater than zero',
  mma: 'MMA',
  counterStrike: 'Counter Strike',
  rugbyUnion: 'Rugby Union',
  valorant: 'Valorant',
  cricket: 'Cricket',
  dota: 'DOTA-2',
  rugbyLeague: 'Rugby League',
  hilo: 'Hilo',
  crash: 'Crash',
  cancelBetSuccessfully: 'Bet cancelled',
  start: 'Start',
  invalidBetAmount: 'Bet amount is invalid',
  zeroError: 'Must be more than 0',
  flipCoin: 'Coin Flip',
  customs: 'Customs',
  redeemCode: 'REDEEM COUPON CODE',
  couponText: 'We regularly post these on our',
  copyrightText: 'Copyright © {{year}} coinbatting.app. All rights reserved. Coinbatting is a brand name of Coinbatting B.V. Company Address: Abraham de Veerstraat 9, Willemstad, Curaçao. Registration #165595.',
  platform: 'Platform',
  support: 'Support',
  faq: 'FAQ',
  partnershipProgram: 'Partnership Program',
  blog: 'Blog',
  helpCenter: 'Help Center',
  aboutUs: 'About us',
  supportAndSocial: 'Support and Social',
  community: 'Community',
  facebook: 'Facebook',
  twitter: 'Twitter',
  instagram: 'Instagram',
  discord: 'Discord',
  english: 'English',
  hindi: 'Hindi',
  french: 'French',
  legal: 'Legal',
  cryptoTransactions: 'Crypto Transactions',
  sendersName: "Sender's name",
  hideLoginHistory: 'Hide login history',
  loginMethod: 'Login method',
  deviceType: 'Device type',
  ip: 'IP',
  tradingDefinition: 'Crypto trading is not gambling by definition, therefore it is not covered by our gaming license.',
  perks: 'perks',
  connected: 'Connection established',
  twitch: 'Twitch',
  connect: 'Connect',
  setUpGoogleAuthenticator: 'SET UP GOOGLE AUTHENTICATOR',
  twoFACode: '2FA CODE',
  downloadTheGoogleAuthenticator: '1. Download the Google Authenticator app for iPhone or Android',
  saveTheFollowingAccountToken: '2. Save the following Account Token (Key) in a secure place',
  accountTokenKey: 'Account Token (Key)',
  scanQRCodeWithApp: '3. Scan QR Code with the Google Authenticator app',
  enterTheTokenBelow: '4. Enter the Token below',
  copied: 'Copied',
  code: 'Code',
  furtherVerificationRequired: 'Further Verification Required',
  firstName: 'First name',
  lastName: 'Last name',
  firstNameRequired: 'Please enter first name.',
  lastNameRequired: 'Please enter last name.',
  firstNameInvalid: 'First name cannot contain numbers or special characters.',
  lastNameInvalid: 'Last name cannot contain numbers or special characters.',
  dateOfBirth: 'Date of birth',
  year: 'Year',
  addressLine: 'Address line',
  addressLineTwo: 'Address line 2',
  city: 'City',
  province: 'Province',
  postalCode: 'Postal code',
  country: 'Country',
  submitInformation: 'Submit information',
  level: 'Level',
  required: 'Required',
  rejected: 'Rejected',
  completed: 'Completed',
  cancelled: 'Cancelled',
  onHold: 'On Hold',
  kycRequestSubmittedSuccessfully: 'KYC request submitted',
  reRequested: 'Re-requested',
  cashBalance: 'Cash Balance',
  bonusBalance: 'Bonus Balance',
  specialBonus: 'Special Bonus',
  today: 'Today',
  noRewards: 'No Rewards',
  viewPendingRewards: 'View Pending Rewards',
  totalClaimed: 'Total Claimed',
  pendingRewards: 'Pending Rewards',
  amount: 'Amount',
  others: 'Others',
  createdAt: 'Created at',
  horseRacing: 'Horse Racing',
  addClutchToHomeScreen: 'Add Coinbatting to Home Screen',
  oneTabAccess: '1-tap access on your phone',
  install: 'Install',
  addToHome: 'Add to home screen',
  inChromeSafari: 'In Chrome/Safari, tap the',
  buttonAndChoose: 'button and choose',
  afterCompletingThisStep: 'After completing this step, access Coinbatting with one tap on your phone!',
  settlementId: 'Settlement ID',
  commission: 'Commission',
  totalCommission: 'Total Commission',
  commissionSettlement: 'Commission Settlement',
  startplaying: 'PLAY NOW',
  forgotPassword: 'Forgot password',
  resetPassword: 'Reset password',
  locked: 'Locked',
  unlocked: 'Unlocked',
  yourRank: 'Your rank',
  nextRanks: 'Next ranks',
  allRanks: 'All ranks',
  bonusClaimedSuccessfully: 'Bonus claimed',
  passwordUpdated: 'Password updated!',
  thatsOkayItHappens: "That's okay. It happens. Click on the button below to continue. Email",
  passwordsMustMatch: 'Passwords must match',
  youNearlyThere: 'You nearly there!',
  weSendYouVerificationEmail: 'We sent you a verification email. Please check your email and verify your account.',
  verifyEmailAddress: 'Verify Email Address',
  pleaseNoteThatTheLinkWillExpire: 'Please note that this link will expire in 5 days, if you have not signed up to Coinbatting gaming, please ignore this email. Thanks',
  autoBetStops: 'Auto bets stops due to bet amount limit exceed',
  casinoBets: 'Casino bets',
  sportsBet: 'Sports bets',
  cryptoTrades: 'Crypto trades',
  customBets: 'Custom bets',
  nothingFound: 'Nothing found',
  bonus: 'Bonus',
  claimedAt: 'Claimed at',
  available: 'Available',
  previous: 'Previous',
  next: 'Next',
  tooManyRequests: 'Too many requests.',
  limitUpdatedSuccessFully: 'Limit updated',
  youLost: 'You lost',
  cashOutFailed: 'Cash-out failed',
  betAlreadyPlaced: 'Bet already placed',
  betCashedOut: 'Bet cashed out',
  noFavouritesIn: 'No favourites in',
  clutchTeam: 'Coinbatting Team',
  fiatAmount: 'Fiat Amount',
  cryptoAmount: 'Crypto Amount',
  moonpay: 'Moonpay',
  paymentMethod: 'Payment Method',
  transactionId: 'Transaction Id',
  address: 'Address',
  comingSoon: 'Coming Soon!',
  minOneCharacterRequired: 'Minimum one character required',
  verifyOtp: 'Verify OTP',
  noResults: 'No results',
  moreFromClutch: 'More from coinbatting',
  betaFilledText: 'Leave your details below, and we’ll notify you as soon as more spots open!',
  telegram: 'Telegram',
  telegramPlaceholder: 'Enter @Username',
  twitterX: 'Twitter / X',
  twitterPlaceholder: 'Enter @Username',
  betaThankyouTitle: 'You\'re on the waitlist',
  betaThankyouText: 'Join & Share for More Chances to be Rewarded!',
  share: 'Share',
  join: 'Join',
  nonCashBalance: 'Non Cash Balance',
  bonusActivatedSuccessfully: 'Bonus activated',
  tryAgain: 'Try again',

  // Prediction Market translations (ported from B2B)
  somethingWentWrongPleaseTryAgain: 'Something went wrong. Please try again.',
  market: 'Market',
  buy: 'Buy',
  sell: 'Sell',
  yes: 'Yes',
  no: 'No',
  yesCents: 'Yes {{cents}}¢',
  noCents: 'No {{cents}}¢',
  upCents: 'Up {{cents}}¢',
  downCents: 'Down {{cents}}¢',
  split: 'Split',
  merge: 'Merge',
  shares: 'Shares',
  refresh: 'Refresh',
  loading: 'Loading',
  gotIt: 'Got it',
  portfolio: 'Portfolio',
  rules: 'Rules',
  volume: 'Volume',
  category: 'Category',
  notAvailable: 'N/A',
  closed: 'Closed',
  removed: 'Removed',
  resolved: 'Resolved',
  settled: 'Settled',
  ask: 'Ask',
  bid: 'Bid',
  asks: 'Asks',
  bids: 'Bids',
  outcome: 'Outcome',
  options: 'Options',
  history: 'History',
  positions: 'Positions',
  orders: 'Orders',
  activity: 'Activity',
  comments: 'Comments',
  delete: 'Delete',
  reply: 'Reply',
  postComment: 'Post Comment',
  likeCount: 'Like ({{count}})',
  limitPrice: 'Limit price',
  postOnly: 'Post-only',
  youPay: 'You pay',
  shareCost: 'Share cost',
  toWin: 'To Win',
  youWillReceive: 'You\'ll receive',
  averagePrice: 'Average price',
  payable: 'Payable',
  processingFee: 'Processing fee',
  processingFees: 'Processing fees',
  estProcessingFee: 'Est. processing fee',
  estProcessingFeeIncluded: 'Est. processing fee (included)',
  processingFeeRefundable: 'Processing fee (refundable)',
  showMore: 'show more...',
  feePerShareIfItFillsNow: 'Fee per share if it fills now',
  marketSettled: 'This market settled',
  resultDeclared: 'This market\'s result',
  awaitingSettlement: 'Awaiting settlement...',
  noMatchResult: 'No match',
  noMatchOnlyOneUser: 'No match: only one user traded',
  noMatchAllSameSide: 'No match: all trades were on the same side',
  noMatchBelowMinimum: 'No match: total amount was under $1.00',
  previousRound: 'Previous market',
  previousRoundSettled: 'Previous market settled',
  previousRoundPending: 'Previous market result',
  previousRoundResult: 'Closed at {{time}} market · {{winners}} won',
  outcomeShares: '{{outcome}} shares',
  avgOutcomePrice: 'Avg {{outcome}} Price',
  splitCollateralIntoShares: 'Split collateral into {{yes}} and {{no}} shares for this market.',
  mergeMatchedSharesIntoCollateral: 'Merge matched {{yes}} and {{no}} shares back into collateral.',
  notEnoughYesAndNoSharesToMerge: 'Not enough {{yes}} and {{no}} shares to merge.',
  equalYesAndNoShares: 'Equal {{yes}} & {{no}} shares · {{marketTitle}}',
  amountYesAndNo: '{{amount}} {{yes}} + {{amount}} {{no}}',
  sharesYesAndNo: '{{shares}} {{yes}} + {{shares}} {{no}}',
  goToLiveMarket: 'Go to live market',
  youWonAmount: 'You won {{amount}}',
  youLostAmount: 'You lost {{amount}}',
  noPositionLastRound: 'You had no position in this round',
  tradingClosedForThisOption: 'Trading is closed for this option.',
  goBack: 'Go back',
  yourPosition: 'Your position',
  availableToTrade: 'Available to trade',
  yesShares: 'Yes shares',
  noShares: 'No shares',
  avgYesPrice: 'Avg Yes Price',
  avgNoPrice: 'Avg No Price',
  payoutProfitLoss: 'Payout P/L',
  won: 'Won',
  outcomeWon: '{{outcome}} won',
  buyOutcome: 'Buy {{outcome}}',
  sellOutcome: 'Sell {{outcome}}',
  decreaseAmount: 'Decrease amount',
  increaseAmount: 'Increase amount',
  decreaseShares: 'Decrease shares',
  increaseShares: 'Increase shares',
  decreaseLimitPrice: 'Decrease limit price',
  increaseLimitPrice: 'Increase limit price',
  nobodySellingRightNow: 'Nobody is selling right now. Try a limit order so yours can wait.',
  nobodyBuyingRightNow: 'Nobody is buying right now. Try a limit order so yours can wait.',
  tooMuchMaxBuy: 'Too much. Max you can buy now is {{amount}}$.',
  tooManySharesMaxSell: 'Too many shares. Max you can sell now is {{amount}}.',
  restAsMakerOnly: 'Rest as maker only; rejected if it would take liquidity',
  // mergeMatchedSharesIntoCollateral: 'Merge matched Yes and No shares back into collateral.',
  sharesPerSide: 'Shares (per side)',
  // splitCollateralIntoShares: 'Split collateral into Yes and No shares for this market.',
  closeTradePanel: 'Close trade panel',
  openTradePanel: 'Open trade panel',
  orderSummary: 'Order summary',
  youSell: 'You sell',
  youMerge: 'You merge',
  estProceedsAtMarket: 'Est. proceeds at market',
  splitCollateral: 'Split collateral',
  mergeShares: 'Merge shares',
  splitHasNoProcessingFee: 'Split has no processing fee.',
  mergeHasNoProcessingFee: 'Merge has no processing fee.',
  includedInWhatYouPay: 'Included in what you pay. Applies when your order matches available offers.',
  deductedFromWhatYouReceive: 'Deducted from what you receive when your order matches available bids.',
  heldWithYourOrder: 'Held with your order. Refunded if it waits on the book. Kept only if it fills right away.',
  onlyIfOrderFillsRightAway: 'Only if your order fills right away — deducted from proceeds. No fee if it waits on the book.',
  makerFeeRebateExplanation: 'If someone else takes your waiting order, you can earn {{rebatePercent}}% of their fee.',
  postOnlyOrderExplanation: 'Post-only: this order only waits. If it would fill right away, it is cancelled and you get your money back.',
  notEnoughMoneyInWallet: 'Not enough money in your wallet.',
  // notEnoughYesAndNoSharesToMerge: 'Not enough Yes and No shares to merge.',
  notEnoughSharesToSell: 'You do not have that many shares to sell.',
  orderCrossesOwnSellOrder: 'Order would cross your own sell order on this outcome. Cancel or lower that sell first.',
  orderCrossesOwnOppositeBuy: 'Order would cross your own opposite-side buy (Yes+No >= 100¢). Cancel or adjust that order first.',
  orderCrossesOwnBuyOrder: 'Order would cross your own buy order on this outcome. Cancel or raise that buy first.',
  placedBuyLimitOrder: 'Placed buy limit order of {{shares}} shares at {{price}} price',
  placedSellLimitOrder: 'Placed sell limit order of {{shares}} shares at {{price}} price',
  placedBuyMarketOrder: 'Placed buy market order of {{amount}} amount',
  placedSellMarketOrder: 'Placed sell market order of {{shares}} shares',
  mergedYesAndNoShares: 'Merged {{quantity}} yes and no shares into {{amount}} amount',
  splitAmountIntoYesAndNoShares: 'Splitted {{amount}} amount into {{yesShares}} yes shares and {{noShares}} no shares',
  closedBuyLimitOrder: 'Closed buy limit order of {{remainingShares}} shares at {{price}} price, total {{shares}}',
  closedSellLimitOrder: 'Closed sell limit order of {{remainingShares}} shares at {{price}} price, total {{shares}}',
  closedBuyMarketOrder: 'Closed buy market order of {{remainingAmount}} amount, total {{amount}}',
  closedSellMarketOrder: 'Closed sell market order of {{remainingShares}} shares, total {{shares}}',
  boughtSharesFromSeller: 'Bought {{quantity}} shares at {{price}} price from {{sellerName}}',
  soldSharesToBuyer: 'Sold {{quantity}} shares at {{price}} price to {{buyerName}}',
  marketResolvedWithOutcome: 'Market resolved with {{outcome}} outcome. Payout: ${{payout}} ({{winningShares}} winning shares).',
  buyerReceivedSharesSystemMinted: '{{buyerName}} received {{quantity}} shares at {{price}} (system minted)',
  buyerBoughtSharesFromSeller: '{{buyerName}} bought {{quantity}} shares at {{price}} from {{sellerName}}',
  sellerSoldSharesToSystem: '{{sellerName}} sold {{quantity}} shares at {{price}} to SYSTEM',
  sellerSoldSharesToBuyer: '{{sellerName}} sold {{quantity}} shares at {{price}} to {{buyerName}}',
  unreadNotifications: '{{count}} unread notifications',
  recentCount: '{{count}} recent',
  loadingNotifications: 'Loading notifications...',
  noNotificationsYet: 'No notifications yet. You will be notified when orders are matched, completed, or markets resolve.',
  activityUpdate: 'Activity update',
  marketResolved: 'Market resolved',
  marketQuestionResolved: 'Market "{{questionTitle}}" has been resolved.',
  walletUpdated: 'Wallet updated',
  justNow: 'Just now',
  pickAMarket: 'Pick a market',
  pickAMarketDescription: 'Open any market and choose Yes or No based on your prediction. Then use the order panel to get shares.',
  preferLimitOrders: 'Prefer Limit orders',
  preferLimitOrdersDescription: 'Start here. Set the exact price (¢) and number of shares you want. Your order rests on the book until someone matches it — so you control the price.',
  noFillUseSplit: 'No fill? Use Split',
  noFillUseSplitDescription: 'If there isn\'t enough liquidity to fill a Limit order, Split your collateral into equal Yes and No shares. You can then sell the side you don\'t want.',
  needSpeedMarketOrders: 'Need speed? Market orders',
  needSpeedMarketOrdersDescription: 'Market orders fill instantly against the current order book. Use them when you want shares now and are okay paying the live market price.',
  holdOrCashOut: 'Hold or cash out',
  holdOrCashOutDescription: 'Sell anytime before resolution, or hold until the market settles. Winning shares pay $1 each; losing shares settle at $0.',
  restsOnTheBookUntilMatched: 'Rests on the book until matched',
  convertCashIntoYesAndNoShares: 'Convert cash into Yes + No shares',
  estShares: 'Est. shares',
  fillsInstantlyAtBookPrices: 'Fills instantly at book prices',
  resolvedYes: 'Resolved · Yes',
  payoutCredited: 'Payout credited',
  closeHowItWorks: 'Close how it works',
  tryItOut: 'Try It Out?',
  demoGuide: 'Guide',
  demoGuideReopen: 'Reopen demo guide',
  demoGuideSkip: 'Skip guide',
  demoGuideFinish: 'Finish',
  demoGuideStepOf: 'Step {{current}} of {{total}}',
  demoGuideBack: 'Back',
  demoGuideWelcomeTitle: 'Welcome to the playground',
  demoGuideWelcomeBody: 'This is a safe demo market with play money. I will point at each piece of the UI and explain what it does — try the action if you like, or tap Next anytime.',
  demoGuideWelcomeHint: 'You start with $1000 demo balance. Nothing here is real.',
  demoGuideLimitTitle: 'Prefer Limit orders',
  demoGuideLimitBody: 'A Limit order lets you set the exact price (¢) and number of shares. It rests on the book until someone matches it — so you control the price instead of taking whatever is live.',
  demoGuideLimitHint: 'I opened Limit and suggested Buy Yes at 45¢ × 10. Submit if you want to try it, or Next to keep reading.',
  demoGuideOrderbookTitle: 'Your order on the book',
  demoGuideOrderbookBody: 'The orderbook shows resting bids and asks. When you place a limit order, it appears here (often marked You) until it fills or you cancel it.',
  demoGuideOrderbookHint: 'If you have no resting order yet, I place a small demo bid so you can see how it looks.',
  demoGuidePostOnlyTitle: 'Post-only (maker only)',
  demoGuidePostOnlyBody: 'Post-only means your limit buy only rests as a maker. If the price would fill immediately against an ask, the order is rejected and your money comes back — useful when you never want to take liquidity.',
  demoGuidePostOnlyHint: 'Post-only is checked with a non-crossing 45¢ bid ready. Try submit, or Next to continue.',
  demoGuideCancelTitle: 'Cancel a resting order',
  demoGuideCancelBody: 'Changed your mind? Open orders live under My Position. Cancelling unlocks cash reserved on buys (or shares locked on sells) so you can reuse them.',
  demoGuideCancelHint: 'Use Cancel on a row here if you want to practice — I keep a resting bid available for you.',
  demoGuideMarketTitle: 'Need speed? Market orders',
  demoGuideMarketBody: 'Market orders fill instantly against the current book. Use them when you want shares now and are okay paying live ask prices instead of waiting on your own limit.',
  demoGuideMarketHint: 'I set a $5 Buy on Market. Submit to see an instant fill, or Next to move on.',
  demoGuideMintTitle: 'No asks? Mint still works',
  demoGuideMintBody: 'If nobody is selling, you can still get shares. The engine can mint Yes+No from collateral by matching your buy against an opposite-side bid — so empty asks do not always mean “stuck.”',
  demoGuideMintHint: 'I cleared asks on this option. A $5 Market buy is ready — watch shares appear even with an empty ask side.',
  demoGuideSplitTitle: 'No fill? Use Split',
  demoGuideSplitBody: 'Split turns collateral into equal Yes and No shares instantly — no counterparty needed. Handy when the book is thin and you want inventory so you can sell the side you do not want later.',
  demoGuideSplitHint: 'I suggested splitting $10. Try it to see both Yes and No rise, or Next to continue.',
  demoGuideMergeTitle: 'Merge back to cash',
  demoGuideMergeBody: 'Merge is the reverse of Split: burn equal Yes and No shares to get collateral back. Useful when you hold both sides and want to flatten into cash.',
  demoGuideMergeHint: 'I suggested merging 5 per side. You need matching available Yes and No — Split first if needed.',
  demoGuideResolveTitle: 'Close and settle',
  demoGuideResolveBody: 'When trading ends, the market closes and then settles. Winning shares pay $1 each; losing shares settle at $0. In demo, Manage market lets you simulate close → pick a winner → settle.',
  demoGuideResolveHint: 'Open the panel if it is not open. Close first, then pick Yes/No and Settle for the selected option.',
  demoGuideDoneTitle: 'You have the basics',
  demoGuideDoneBody: 'Limit for price control, post-only to stay maker-only, cancel to free reserved funds, market for speed, mint when asks are empty, split/merge for inventory, and manage market for resolution.',
  demoGuideDoneHint: 'Replay anytime from the Guide button. Demo money resets when you re-enter demo mode.',
  demoGuideWaitingForAction: 'Finish the highlighted action to continue.',
  demoGuideDoThisFirst: 'Do this first',
  willThereBeAUsRecessionThisYear: 'Will there be a US recession this year?',
  exitTutorialAndReturnToMarkets: 'Exit tutorial and return to markets',
  exitDemo: 'Exit demo',
  howItWorks: 'How it works',
  ganamosPolyTrade: 'Ganamos PolyTrade',
  trending: 'Trending',
  new: 'New',
  buyYes: 'Buy Yes',
  breaking: 'Breaking',
  noBreakingMarketsRightNow: 'No breaking markets right now.',
  backToMarkets: 'Back to markets',
  markets: 'Markets',
  openFullMarket: 'Open full market',
  tradeMarket: 'Trade market',
  previousMarket: 'Previous market',
  nextMarket: 'Next market',
  breakingMarkets: 'Breaking markets',
  showBreakingMarket: 'Show breaking market {{index}}',
  featuredMarkets: 'Featured markets',
  topMovers: 'Top Movers',
  liveTrades: 'Live Trades',
  featuredMarket: 'Featured Market',
  untitledMarket: 'Untitled market',
  traders: 'Traders',
  endsIn: 'Ends in',
  showFeaturedMarket: 'Show featured market {{index}}',
  openNewsHeadline: 'Open news: {{headline}}',
  openNewsStatus: 'Open news: {{statusText}}',
  news: 'News',
  minimizeNews: 'Minimize news',
  expandNews: 'Expand news',
  closeNews: 'Close news',
  liveWire: 'Live wire',
  categoryNews: '{{category}} news',
  categoryDesk: '{{category}} desk',
  topHeadlinesAndRelatedCoverage: 'Top headlines and related coverage for this market category',
  topHeadlinesCount: 'Top {{count}} headlines',
  moreRelevantNews: 'More relevant news',
  noNewsStoriesForThisCategoryYet: 'No news stories for this category yet.',
  pullingHeadlinesFromTheWire: 'Pulling headlines from the wire…',
  scanningWire: 'Scanning wire…',
  categoryWaitingForStories: '{{category}} · waiting for stories',
  categoryStoriesCount: '{{category}} · {{count}} stories',
  searchMarkets: 'Search markets...',
  searchPortfolioActivity: 'Search portfolio activity',
  refreshPortfolioActivity: 'Refresh portfolio activity',
  portfolioSections: 'Portfolio sections',
  noPositionsFound: 'No positions found',
  yourOwnedPositionsWillAppearHere: 'Your owned positions will appear here.',
  noOrdersFound: 'No orders found',
  marketOrdersWillAppearInThisSection: 'Market orders will appear in this section.',
  limitOrdersWillAppearInThisSection: 'Limit orders will appear in this section.',
  noActivityYet: 'No activity yet',
  completedTradesAndSettlementsWillBeListedHere: 'Completed trades and settlements will be listed here.',
  cancelThisOrder: 'Cancel this order?',
  cancelThisOrderDescription: 'This will remove your open limit order from the book. You can place a new one anytime.',
  keepOrder: 'Keep order',
  cancelOrder: 'Cancel order',
  yourTradingDesk: 'Your trading desk',
  stateFilters: 'State filters',
  tablePagination: 'Table pagination',
  pagination: 'Pagination',
  previousPage: 'Previous page',
  nextPage: 'Next page',
  noDataAvailable: 'No data available',
  dataWillAppearHere: 'Data will appear here',
  thumbnail: 'Thumbnail',
  actions: 'Actions',
  rowThumbnail: 'Row thumbnail',
  yourPerformance: 'Your Performance',
  walletBalance: 'Wallet Balance',
  totalProfitIncludingTakerFee: 'Total Profit Including Taker Fee',
  totalProfit: 'Total Profit',
  hideTakerFee: 'Hide taker fee',
  showTakerFee: 'Show taker fee',
  profitOverTime: 'Profit Over Time',
  noChartDataAvailable: 'No chart data available',
  profitHistoryWillAppearAsTradesArePlaced: 'Profit history will appear as trades are placed.',
  profitChartTimeRange: 'Profit chart time range',
  userActivity: 'User activity',
  userActivityTitle: 'User Activity',
  userActivityTabs: 'User activity tabs',
  refreshUserActivity: 'Refresh user activity',
  addYourComment: 'Add your comment',
  shareYourThoughtsAboutThisMarket: 'Share your thoughts about this market...',
  anonymous: 'anonymous',
  hideReplies: 'Hide Replies',
  showReplies: 'Show Replies',
  writeAReply: 'Write a reply...',
  loadingEllipsis: 'Loading...',
  recentMarketBuysAndSellsWillAppearHere: 'Recent market buys and sells will appear here.',
  topHolders: 'Top Holders',
  topPositions: 'Top Positions',
  noTopPositionsFound: 'No top positions found',
  topPositionsWillAppearHereWithHighestRealizedPnl: 'The top positions will appear here with the highest realized PNL',
  yesHolders: 'Yes Holders',
  noHolders: 'No Holders',
  noTopHoldersFoundForYesOutcome: 'No top holders found for Yes outcome',
  topHoldersWillAppearHereForYesOutcome: 'The top holders will appear here for Yes outcome',
  noTopHoldersFoundForNoOutcome: 'No top holders found for No outcome',
  topHoldersWillAppearHereForNoOutcome: 'The top holders will appear here for No outcome',
  optionDetailsTabs: 'Option details tabs',
  orderbookOutcome: 'Orderbook outcome',
  orderbook: 'Orderbook',
  graph: 'Graph',
  myPosition: 'My Position',
  yesBook: 'Yes book',
  noBook: 'No book',
  spread: 'Spread',
  you: 'You',
  noAsks: 'No asks',
  noBids: 'No bids',
  loadingPosition: 'Loading position...',
  yourOrders: 'Your orders',
  marketOrdersForThisOptionWillAppearHere: 'Market orders for this option will appear here.',
  limitOrdersForThisOptionWillAppearHere: 'Limit orders for this option will appear here.',
  rulesAndMarketContext: 'Rules and market context',
  marketResolvesBasedOnListedCriteriaAndFinalOutcomeData: 'Market resolves based on listed criteria and final outcome data.',
  matchingEngineSettlesOpenOrdersUsingMarketResolutionRules: 'Matching engine settles open orders using market resolution rules.',
  ambiguousOutcomesAreHandledByPlatformAdjudicationPolicy: 'Ambiguous outcomes are handled by platform adjudication policy.',
  defaultPredictionMarketRules: `
  Rules:
  - This market resolves based on the outcome described in the question. Resolution will use publicly available and reliable sources such as official statements, verified data providers, or reputable news organizations. 
  - If the outcome becomes clear before the listed end date, the market may resolve early. If the event cannot be determined or the question becomes ambiguous, the platform may resolve the market using best judgment based on available information.
  - All resolutions are final.`,
  pleaseLogInToFavouriteQuestions: 'Please log in to favourite questions.',
  removeFromFavourites: 'Remove from favourites',
  addToFavourites: 'Add to favourites',
  unableToUpdateFavouriteQuestionPleaseTryAgain: 'Unable to update favourite question. Please try again.',
  marketOrderInProgress: 'Market order in progress',
  noActiveMarketOrder: 'No active market order',
  marketOrderRunning: 'Market order running',
  remainingAmount: 'Remaining: ${{amount}}',
  remainingShares: 'Remaining: {{shares}} shares',
  statusState: 'Status: {{state}}',
  noMarketOrderRunning: 'No market order running. You can find past market orders in the Orders tab on your Portfolio page.',
  withdraw: 'Withdraw',
  closeWalletActivityModal: 'Close wallet activity modal',
  enterAmountToAction: 'Enter amount to {{action}}',
  depositSuccessful: 'Deposit successful',
  depositFailedPleaseTryAgain: 'Deposit failed. Please Try Again.',
  withdrawalSuccessful: 'Withdrawal successful',
  withdrawFailedPleaseTryAgain: 'Withdraw failed. Please Try Again.',
  mergeSuccessfulBalanceCredited: 'Merge successful. Balance credited.',
  mergeSuccessfulCreditPending: 'Merge successful. Credit pending — balance will update shortly.',
  orderPlacedSuccessfully: 'Order placed successfully',
  placeOrderFailedPleaseTryAgain: 'Place order failed. Please Try Again.',
  orderCancelledSuccessfully: 'Order cancelled successfully',
  cancelLimitOrderFailedPleaseTryAgain: 'Cancel limit order failed. Please Try Again.',
  commentAdded: 'Comment added',
  addCommentFailedPleaseTryAgain: 'Add comment failed. Please Try Again.',
  commentDeleted: 'Comment deleted',
  deleteCommentFailedPleaseTryAgain: 'Delete comment failed. Please Try Again.',
  failedToLoadNotifications: 'Failed to load notifications',
  commentCannotBeEmpty: 'Comment cannot be empty.',
  commentNotFound: 'Comment not found.',
  demoMultiOutcomeMarket: 'Demo multi-outcome market',
  outcomeAlpha: 'Outcome Alpha',
  outcomeBeta: 'Outcome Beta',
  outcomeGamma: 'Outcome Gamma',
  greatMarketToLearnLimitOrders: 'Great market to learn limit orders — try placing a bid below the current price.',
  theOrderbookUpdatesLiveOnceYouStartPlacingDemoOrders: 'The orderbook updates live once you start placing demo orders.',
  demoOutcome: 'Demo outcome',
  demoMarketControls: 'Demo market controls',
  simulateCloseAndSettlementToSeeHowTheMarketBehaves: 'Simulate close and settlement to see how the market behaves.',
  closePanel: 'Close panel',
  closeMarket: 'Close market',
  tradingOpen: 'Trading open',
  stopsTradingClearsTheOrderbookAndClosesOpenOrders: 'Stops trading, clears the orderbook, and closes open orders. Remaining prepaid amounts on bid orders return to your wallet. Positions stay open until settlement.',
  marketClosed: 'Market closed',
  settleMarket: 'Settle market',
  ready: 'Ready',
  awaitingClose: 'Awaiting close',
  pickTheWinningOutcomeDescription: 'Pick the winning outcome. Winning shares pay $1 each, positions are cleared, and options show as settled with the final result.',
  winningOutcome: 'Winning outcome',
  settlementOutcome: 'Settlement outcome',
  closeManageMarketPanel: 'Close manage market panel',
  manageMarket: 'Manage market',
  manageDemoMarket: 'Manage demo market',
  noChartDataYet: 'No chart data yet',
  priceHistoryWillAppearHereAsTradesHappen: 'Price history will appear here as trades happen.',
  chartTimeRange: 'Chart time range',
  allMarkets: 'All Markets',
  backToCollateral: 'Back to collateral · {{marketTitle}}',
  demo: 'Demo',
  depositing: 'Depositing...',
  // equalYesAndNoShares: 'Equal Yes & No shares · {{marketTitle}}',
  estValue: 'Est. {{value}}',
  favouriteQuestions: 'Favourite Questions',
  feePerShareFormula: 'Fee per share (¢) = price × (100 − price) × {{coefficient}} / 10,000',
  limitBuy: 'Limit buy',
  limitSell: 'Limit sell',
  marketBuyOn: 'Market buy on {{marketTitle}}',
  marketSellOn: 'Market sell on {{marketTitle}}',
  marketResolutionPayoutReceived: 'Market resolution payout received. New balance: {{currency}} {{formattedBalance}}',
  marketsPagination: 'Markets pagination',
  noFavouriteQuestionsYet: 'No favourite questions yet.',
  noTitle: 'No title',
  optionNumber: 'Option {{number}}',
  postOnlyLimitBuy: 'Post-only limit buy',
  system: 'SYSTEM',
  unknownOrderType: 'Unknown order type: {{orderType}}',
  withdrawing: 'Withdrawing...',
  yourBalanceWasCredited: 'Your balance was credited. New balance: {{currency}} {{formattedBalance}}',
  yourBalanceWasDebited: 'Your balance was debited. New balance: {{currency}} {{formattedBalance}}',
  thisMarket: 'this market',
  yourPositionText: 'your position',
  // amountYesAndNo: '{{amount}} Yes + {{amount}} No',
  daysAgo: '{{days}}d ago',
  hoursAgo: '{{hours}}h ago',
  minutesAgo: '{{minutes}}m ago',
  outcomeSharesAtMarket: '{{outcome}} shares at market',
  // sharesYesAndNo: '{{shares}} Yes + {{shares}} No',
  sharesOutcomeAtPrice: '{{shares}} {{outcome}} @ {{price}}¢ · {{marketTitle}}',
  sharesOutcome: '{{shares}} {{outcome}} shares',
  cryptoRelativeToday: 'today',
  cryptoRelativeTomorrow: 'tomorrow',
  cryptoRelativeYesterday: 'yesterday',
  cryptoPriceAtTime: '{{asset}} price at {{time}}',
  cryptoUpOrDownAtTime: '{{asset}} Up or Down {{day}} at {{time}}',
  cryptoUpOrDownDay: '{{asset}} Up or Down {{day}}',
  cryptoUpOrDown15min: '{{asset}} Up or Down 15min',
  cryptoMoreThanPrice: 'More than ${{price}}',
  cryptoLessThanPrice: 'Less than ${{price}}',
  // B2C Markets page extras (not in B2B commit UI, but used by CoinBatting Markets)
  vol: 'Vol.',
  yourWatchlist: 'Your Watchlist',
  yourFavouriteMarketsInOnePlace: 'Your favourite markets in one place',
  totalTraders: 'Total Traders',
  totalVolume: 'Total Volume',
  stayAheadWithCategoryMarkets: 'Stay ahead with {{category}} markets',
  categoryNow: '{{category}} Now',
  gridView: 'Grid view',
  listView: 'List view',
}
